import type { AccountType } from '@/entities/account';
import { useOpenAccountAvailabilityStore } from '@/features/account-open';
import { MarkdownText } from '@/shared/components';
import { useAccountCreateModal } from '@/widgets';
import { useTranslation } from 'react-i18next';

interface Props {
  isAssetSelector?: boolean;
  accountType?: AccountType;
}

const InternalTransferInfoBanner = ({
  isAssetSelector,
  accountType,
}: Props) => {
  const { openCreateAccountModal } = useAccountCreateModal(accountType);
  const { openInvestIsAvailable, openMarginIsAvailable, openEarnIsAvailable } =
    useOpenAccountAvailabilityStore();

  const { t } = useTranslation();

  return (
    <div className="pt-[0.4rem] mb-[0.8rem] pb-0 flex flex-col items-start gap-1 w-full">
      <div className="h-px w-full bg-border my-[0.8rem]" />
      <div className="headline4 text-foreground">
        {t('internalTransferModal.exchangeTransferTitle')}
      </div>
      <div className="p6 text-muted-foreground">
        <MarkdownText
          variant="default"
          className="w-full"
          components={{
            p: ({ children, ...props }) => (
              <p {...props} className="p6 text-muted-foreground">
                {children}
              </p>
            ),
            a: ({ children }) => {
              if (!isAssetSelector) {
                return (
                  <button
                    type="button"
                    onClick={() => openCreateAccountModal()}
                    className="p6 text-primary hover:underline cursor-pointer inline pointer-events-auto">
                    {children}
                  </button>
                );
              }
            },
          }}>
          {t(
            `internalTransferModal.${isAssetSelector || (accountType === 'invest' && !openInvestIsAvailable) || (accountType === 'leverage' && !openMarginIsAvailable) || (accountType === 'earn' && !openEarnIsAvailable) ? 'exchangeTransferDescription' : 'exchangeTransferLeverageDescription'}`
          )}
        </MarkdownText>
      </div>
    </div>
  );
};

export { InternalTransferInfoBanner };
